import React from 'react';
import { Text } from '@react-pdf/renderer';

const EditableInput = ({ 
  name, 
  value, 
  onClick, 
  onBlur, 
  readOnly, 
  pdfMode,
  className,
  id
}) => {
  if (pdfMode) {
    return <Text>{value}</Text>;
  }

  return (
    <input
    id={id}
      type="text"
      name={name}
      defaultValue={value}
      onClick={onClick}
      onBlur={(e) => onBlur && onBlur(e)}
      readOnly={readOnly}
      size="5"
      className={className || ''}
    />
  );
};

export default EditableInput;